import { render, staticRenderFns } from "./AssignAgent.vue?vue&type=template&id=f65eb57e&"
import script from "./AssignAgent.vue?vue&type=script&lang=js&"
export * from "./AssignAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports